import BackendService from './BackendService';

async function getCharges(params = {}) {
  return BackendService.getData('/charges/', {}, params);
}

async function getChargeDetails(id) {
  return BackendService.getData(`/charges/${id}/`);
}

async function createCharge(data) {
  return BackendService.postData('/charges/', data);
}

async function updateCharge(id, data) {
  return BackendService.patch(`/charges/${id}/`, data);
}

async function deleteCharge(id) {
  return BackendService.destroy(`/charges/${id}/`);
}

async function createChargeGroup(data) {
  return BackendService.postData('/charge-groups/', data);
}

async function updateChargeGroup(id, data) {
  return BackendService.patch(`/charge-groups/${id}/`, data);
}

async function getChargeGroups(params = {}) {
  return BackendService.getData('/charge-groups/', {}, params);
}

async function deleteChargeGroup(id) {
  return BackendService.destroy(`/charge-groups/${id}/`);
}

const ChargeServices = {
  getCharges,
  getChargeDetails,
  createCharge,
  updateCharge,
  deleteCharge,
  createChargeGroup,
  updateChargeGroup,
  getChargeGroups,
  deleteChargeGroup,
};

export default ChargeServices;